<template>
  <div class="w-full d-flex flex-column pa-3">
    <OAlert class="w-full" info v-if="value.isRoot">
      Este perfil é root, portanto pode ver todos os veículos.
    </OAlert>

    <ACLDisplay :value="value.vehicles" strings="veículo;o">
      <template v-slot:isEmpty>
        <OAlert class="w-full" warning>
          Não existem regras. Este perfil não poderá ver nenhum veículo.
        </OAlert>
      </template>
    </ACLDisplay>

    <div class="pa-3 mt-8">
      <v-btn large color="primary" @click="edit">Editar</v-btn>
    </div>

    <ODialog ref="dialog">
      <v-card>
        <ODialogBar title="Veículos Visíveis" @close="dismiss" />
        <v-card-text class="d-flex flex-wrap pa-3">
          <ACLEditor
            class="pa-3"
            :value="clonedValues"
            strings="veículo;o"
            :allTags="allTags"
          />
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          @apply="apply"
          @cancel="dismiss"
          txtApply="Salvar"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { OrgApi } from '@/models/index.js'
import ACLDisplay from 'oderon-vue/cpts/acl/ACLDisplay.vue'
import ACLEditor from 'oderon-vue/cpts/acl/ACLEditor.vue'
import utils from 'oderon-commons/src/utils.js'

export default {
  components: {
    ACLDisplay,
    ACLEditor
  },
  props: {
    value: { required: true }
  },
  data() {
    return { allTags: [], clonedValues: {} }
  },
  methods: {
    async edit() {
      this.clonedValues = JSON.parse(JSON.stringify(this.value.vehicles || {}))
      let fetcher = new OrgApi(this.value.orgId)
      this.allTags = utils.sortTags(await fetcher.get('vehicles/tags'))
      await this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.dismiss()
      this.$rootLoading(async () => {
        let fetcher = new OrgApi(this.value.orgId)
        let old = await fetcher.get(`profiles/${this.value.id}`)
        old.vehicles = this.clonedValues
        await fetcher.put(`profiles/${this.value.id}`, old)
        this.$snack('Salvo com sucesso')
        this.$emit('reload')
      })
    }
  }
}
</script>
